import React from "react";
import { Head, Scheduler } from "../../components";
import "./workshop.css";

export const Workshop = () => {
  return (
    <>
      <div className="workshop-g">
        <Head title="Talleres" />
        <Scheduler type='WORKSHOP'/>
      </div>
    </>
  );
}

export default Workshop;
